import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2 } from 'lucide-react';
export function IncludesChecklist() {
  const items = ['Protocolos clínicos detallados paso a paso', 'Planillas imprimibles listas para usar desde hoy', 'Task analysis y checklists operativos', 'Scripts y guiones para familias y escuela', 'Contexto 100% argentino: Obras Sociales, CUD, sistema educativo', 'Errores frecuentes y cómo evitarlos', 'Criterios de progreso y toma de decisiones clínicas', 'Formatos de informes para todas las Obras Sociales principales', 'Optimizado para celular, tablet e imprimir', '100% basado en la práctica ABA argentina 2024'];
  return <section className="py-12 bg-cyan-950 border-y border-cyan-900" data-id="element-179">
      <div className="container mx-auto px-4 max-w-5xl" data-id="element-180">
        <h3 className="text-2xl font-bold text-center mb-10 text-white" data-id="element-181">
          Cada tomo incluye:
        </h3>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-x-8 gap-y-4" data-id="element-182">
          {items.map((item, i) => <motion.div key={i} initial={{
          opacity: 0,
          x: -10
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.05
        }} className="flex items-start gap-3 p-3 rounded-lg hover:bg-cyan-900/50 transition-colors" data-id="element-183">
              <CheckCircle2 className="w-5 h-5 text-emerald-400 shrink-0 mt-0.5" data-id="element-184" />
              <span className="text-cyan-50 font-medium text-[16px]" data-id="element-185">
                {item}
              </span>
            </motion.div>)}
        </div>
      </div>
    </section>;
}